import logo from "./logo.svg";
import "./App.css";
import RandomAdvice from "./component/RandomAdvice";

function App() {
  return (
    <div className="App">
      <RandomAdvice />
    </div>
  );
}

export default App;
